import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = () => {
  // Check if admin is logged in (using sessionStorage as set in Login.tsx)
  const isLoggedIn = sessionStorage.getItem('pato_admin_token') === 'logged_in';

  if (!isLoggedIn) {
    return <Navigate to="/admin/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
